// @flow
import React from 'react';
import { Text } from 'trpc-react-native-ui';
import theme from '../../../theme-config';
import { formatDaysLeft } from '../../../lib/date-utils';
import { StyleSheet } from 'react-native';

function getStyles() {
  return StyleSheet.create({
    strongerText: {
      color: theme.secondaryColor,
      fontSize: 20,
      fontWeight: '600',
      marginTop: 8,
      marginBottom: 8,
      textAlign: 'center',
    },
  });
}

const LineInformations = (props: Props) => {
  if (props.daysLeft == null) return null;
  const styles = getStyles();
  const text = formatDaysLeft(props.daysLeft, true);
  return <Text style={[styles.strongerText, props.isModeOn ? {} : { color: 'orange' }]}>{text}</Text>;
};

type Props = {
  daysLeft: ?number,
  isModeOn: boolean,
};

export default LineInformations;
